import styled from "styled-components";

export const StyledArticleAuthorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const StyledAuthorImage = styled.img`
  height: 48px !important;
  width: 48px !important;
  object-fit: cover;
  border-radius: 50%;
`;

export const StyledAuthorDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const StyledAuthorName = styled.span`
  color: rgba(37, 37, 37, 0.80);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.32px;
`;

export const StyledAuthorRole = styled.span`
  color: rgba(37, 37, 37, 0.60);
  font-size: 13px;
  font-weight: 400;
  line-height: 153.846%;
  letter-spacing: 0.26px;
`;
